import React from "react";
import { Link } from "react-router-dom";

import { OverflowTooltip } from "components";

type TableLinkProps = {
	href: string;
	value: string | JSX.Element;
	isTargetBlank?: boolean;
	title?: string;
};

export const TableLink = ({
	href,
	value,
	isTargetBlank = true,
	title,
}: TableLinkProps) => (
	<OverflowTooltip onlyOnLaptop title={title || value}>
		<Link
			to={href}
			target={isTargetBlank ? "_blank" : ""}
			onClick={e => e.stopPropagation()}
		>
			{value}
		</Link>
	</OverflowTooltip>
);
